// extracted by css-extract-rspack-plugin
export default {"title":"uVhbGIyHg8ArzV5A","description":"zSUaAX1whzYw7u79"};